@if (items()?.length) {
  <div
    class="carousel-widget"
    [ngClass]="widgetCssClass()">
    <div class="carousel" [class.hide-button]="hideNavigationButtons() || slidesFitInView()">
      <button
        mat-icon-button
        class="button button--icon button--black button--icon-small carousel-button"
        [class.hidden]="swiperComponent()?.swiper?.isBeginning"
        (click)="swiperComponent()?.swiper?.slidePrev()">
        <lib-icon icon="caret-left" [size]="28"></lib-icon>
      </button>
      <lib-swiper
        class="swiper"
        [ngClass]="cardOrientation()"
        [slides]="items()"
        [performanceMode]="true"
        [options]="swiperOptions()"
        (slideIndexChange)="slideIndexChange($event)">
        <ng-template swiperContent let-slide="item" let-index="index">
          <div
            class="carousel-slide"
            [shouldCreateOverlay]="false"
            [dynamicWidthCoeff]="3"
            [borderStyle]="border()"
            [cardBackground]="slide.enableBackground && { mediaBackground: slide.backgroundImage, backgroundColor: slide.backgroundColor }"
            [ngClass]="{ 
              'no-padding': !slide.applyPadding, 
              'clickable': slide.linkEnabled && slide?.linkToContent?.id,
              'no-shadow': dropShadow(),
              'no-rounding': disableRoundness()
            }"
            [style.--lms-carousel-slide-media-ratio]="(slide.mediaRatioPercent || 50) + '%'"
            [style.backdropFilter]="slide.backgroundBlur ? ('blur(' + slide.backgroundBlur + ')') : ''"
            (click)="navigateToContent.emit(slide?.linkToContent)">
            @if (slide.enableBackground && slide.backgroundVideo) {
              <lib-video
                [src]="slide.backgroundVideo | videoPresign | async"
                class="background-video position-cover"
                [hideControls]="true"
                [loop]="true"
                [autoplay]="true">
              </lib-video>
            }
            @if (showCardEditButton()) {
              <div class="card-actions">
                <button
                  mat-icon-button
                  class="button button--icon button--icon-extra-small button--black"
                  (click)="edit.emit(index)">
                  <lib-icon icon="pencil-simple"></lib-icon>
                </button>
              </div>
            }
            @if (slide.text) {
              <div class="slide-text-container" [class.second-order]="slide.firstContent === contentTypes.MEDIA">
                <div class="ck-text text-scrollbar-container" [ngClass]="slide.alignment">
                  <ng-scrollbar class="slide-text-scrollbar">
                    <div class="slide-text-content" [autoTextDirection]="isTranslation()" [autoTextDirectionValue]="slide.text" [innerHTML]="slide.text | safeHtml"></div>
                  </ng-scrollbar>
                </div>
                @if (!slide.mediaType || slide.mediaType === mediaTypes.NONE || (!slide.mediaImage && !slide.mediaVideo)) {
                  @if (slide.linkEnabled && slide.buttonEnabled) {
                    <div class="slide-text-button">
                      <ng-container *ngTemplateOutlet="slideButton"></ng-container>
                    </div>
                  }
                }
              </div>
            }
            @if (slide.mediaType === mediaTypes.IMAGE && slide.mediaImage) {
              <div
                class="slide-media"
                [shouldCreateOverlay]="false"
                [dynamicWidthCoeff]="3"
                [cardBackground]="{ mediaBackground: slide.mediaImage, backgroundColor: null }">
                <ng-container *ngTemplateOutlet="slideButton"></ng-container>
              </div>
            }
            @if (slide.mediaType === mediaTypes.VIDEO && slide.mediaVideo) {
              <div class="slide-media">
                @if (slide.mediaVideo) {
                  <lib-video
                    [src]="slide.mediaVideo | videoPresign | async"
                    class="background-video position-cover"
                    [hideControls]="true"
                    [loop]="true"
                    [autoplay]="true">
                  </lib-video>
                }
                <ng-container *ngTemplateOutlet="slideButton"></ng-container>
              </div>
            }
            @if (enableCardEmptyState() && !slide.text && !slide.mediaImage && !slide.mediaVideo && !slide.enableBackground) {
              <div class="empty-state">
                <span class="empty-state-title">{{ 'COMMON.no_content_added_yet' | translate }}</span>
                {{ 'COMMON.once_you_add_content_or_page_background_the_will_show' | translate }}
              </div>
            }
          </div>
          <ng-template #slideButton>
            @if (slide.linkEnabled && slide.buttonEnabled) {
              <button
                mat-flat-button
                class="button slide-link-button"
                [style.backdropFilter]="slide.buttonBlur ? ('blur(' + slide.buttonBlur + ')') : ''"
                [style.backgroundColor]="slide.buttonColor"
                [style.color]="slide.buttonTextColor">
                {{ slide?.buttonText }}
              </button>
            }
          </ng-template>
        </ng-template>
      </lib-swiper>
      <button
        mat-icon-button
        class="button button--icon button--icon-small button--black carousel-button"
        [class.hidden]="swiperComponent()?.swiper?.isEnd"
        (click)="swiperComponent()?.swiper?.slideNext()">
        <lib-icon icon="caret-right" [size]="28"></lib-icon>
      </button>
    </div>
    <div class="pagination">
      @for (item of items(); track item; let i = $index) {
        <div
          class="pagination-dot"
          [class.active]="swiperComponent()?.swiper?.activeIndex === i"
        (click)="swiperComponent()?.swiper?.slideTo(i)"></div>
      }
    </div>
  </div>
}
